import React, {
  useEffect,
  useState,
} from "react";

import {
  useDispatch,
  useSelector,
} from "react-redux";

import {
  FiChevronLeft,
  FiChevronRight,
  FiEye,
  FiRefreshCw,
  FiSearch,
  FiX,
} from "react-icons/fi";

import {
  config,
} from "../../../../../utils/apiUrl";

import {
  fetchPlatformSupportTickets,
  fetchPlatformSupportSummary,
  fetchPlatformSupportFilters,
  fetchPlatformSupportById,
  updatePlatformSupportStatus,
  updatePlatformSupportPriority,
  updatePlatformSupportNotes,
  updatePlatformSupportResolution,
  setPlatformSupportFilters,
  selectPlatformSupportState,
} from "../../../../../store/platform/platformSupportSlice";

import "./PlatformSupportPage.css";


const formatLabel =
  (
    value
  ) =>
    String(
      value ||
      ""
    )
      .replace(
        /_/g,
        " "
      )
      .toLowerCase()
      .replace(
        /\b\w/g,
        (
          char
        ) =>
          char.toUpperCase()
      );


const formatDate =
  (
    value
  ) => {

    if (
      !value
    ) {

      return "-";

    }


    const date =
      new Date(
        value
      );


    if (
      Number.isNaN(
        date.getTime()
      )
    ) {

      return "-";

    }


    return date
      .toLocaleString(
        "en-IN"
      );
  };


const fileUrl =
  (
    path
  ) => {

    if (
      !path
    ) {

      return "";

    }


    if (
      /^https?:\/\//i.test(
        path
      )
    ) {

      return path;

    }


    return `${config.site_api}${path}`;
  };


const PlatformSupportPage =
  () => {

    const dispatch =
      useDispatch();


    const {
      tickets,
      selectedTicket,
      summary,
      filters,
      pagination,
      filterOptions,
      listLoading,
      detailsLoading,
      actionLoading,
      error,
    } =
      useSelector(
        selectPlatformSupportState
      );


    const [
      search,
      setSearch,
    ] =
      useState(
        filters.search ||
        ""
      );


    const [
      detailsOpen,
      setDetailsOpen,
    ] =
      useState(
        false
      );


    const [
      internalNotes,
      setInternalNotes,
    ] =
      useState(
        ""
      );


    const [
      resolution,
      setResolution,
    ] =
      useState(
        ""
      );


    const load =
      () => {

        dispatch(
          fetchPlatformSupportTickets(
            filters
          )
        );


        dispatch(
          fetchPlatformSupportSummary()
        );

      };


    useEffect(
      () => {

        dispatch(
          fetchPlatformSupportFilters()
        );

      },
      [
        dispatch,
      ]
    );


    useEffect(
      () => {

        load();

      },
      [
        dispatch,
        filters.page,
        filters.limit,
        filters.status,
        filters.priority,
        filters.category,
        filters.tenantId,
        filters.search,
        filters.fromDate,
        filters.toDate,
      ]
    );


    useEffect(
      () => {

        setInternalNotes(
          selectedTicket
            ?.internalNotes ||
          ""
        );


        setResolution(
          selectedTicket
            ?.resolution ||
          ""
        );

      },
      [
        selectedTicket,
      ]
    );


    const applySearch =
      () => {

        dispatch(
          setPlatformSupportFilters({
            page:
              1,

            search:
              search.trim(),
          })
        );

      };


    const openDetails =
      async (
        id
      ) => {

        setDetailsOpen(
          true
        );


        await dispatch(
          fetchPlatformSupportById(
            id
          )
        );

      };


    const refreshAfterAction =
      () => {

        dispatch(
          fetchPlatformSupportSummary()
        );

      };


    return (
      <div
        className="platform-support-page"
      >

        <div
          className="platform-support-heading"
        >

          <div>
            <span>
              CUSTOMER CARE
            </span>

            <h2>
              Support Tickets
            </h2>

            <p>
              Review customer issues across marketplace and tenant storefronts.
            </p>
          </div>


          <button
            type="button"
            onClick={
              load
            }
          >
            <FiRefreshCw />

            Refresh
          </button>

        </div>


        <div
          className="platform-support-summary"
        >

          <article>
            <span>
              Total
            </span>

            <strong>
              {
                summary.total
              }
            </strong>
          </article>


          <article>
            <span>
              New
            </span>

            <strong>
              {
                summary.NEW
              }
            </strong>
          </article>


          <article>
            <span>
              In Progress
            </span>

            <strong>
              {
                summary.IN_PROGRESS
              }
            </strong>
          </article>


          <article>
            <span>
              Resolved
            </span>

            <strong>
              {
                summary.RESOLVED
              }
            </strong>
          </article>

        </div>


        <div
          className="platform-support-filters"
        >

          <div
            className="platform-support-search"
          >

            <FiSearch />

            <input
              value={
                search
              }
              onChange={
                (
                  event
                ) =>
                  setSearch(
                    event.target.value
                  )
              }
              onKeyDown={
                (
                  event
                ) => {

                  if (
                    event.key ===
                    "Enter"
                  ) {

                    applySearch();

                  }

                }
              }
              placeholder="Search ticket, customer, mobile, order..."
            />


            <button
              type="button"
              onClick={
                applySearch
              }
            >
              Search
            </button>

          </div>


          <select
            value={
              filters.status
            }
            onChange={
              (
                event
              ) =>
                dispatch(
                  setPlatformSupportFilters({
                    page:
                      1,

                    status:
                      event.target.value,
                  })
                )
            }
          >
            <option value="">
              All Statuses
            </option>

            {
              filterOptions
                .statuses
                .map(
                  (
                    item
                  ) => (
                    <option
                      key={
                        item
                      }
                      value={
                        item
                      }
                    >
                      {
                        formatLabel(
                          item
                        )
                      }
                    </option>
                  )
                )
            }
          </select>


          <select
            value={
              filters.priority
            }
            onChange={
              (
                event
              ) =>
                dispatch(
                  setPlatformSupportFilters({
                    page:
                      1,

                    priority:
                      event.target.value,
                  })
                )
            }
          >
            <option value="">
              All Priorities
            </option>

            {
              filterOptions
                .priorities
                .map(
                  (
                    item
                  ) => (
                    <option
                      key={
                        item
                      }
                      value={
                        item
                      }
                    >
                      {
                        formatLabel(
                          item
                        )
                      }
                    </option>
                  )
                )
            }
          </select>


          <select
            value={
              filters.category
            }
            onChange={
              (
                event
              ) =>
                dispatch(
                  setPlatformSupportFilters({
                    page:
                      1,

                    category:
                      event.target.value,
                  })
                )
            }
          >
            <option value="">
              All Categories
            </option>

            {
              filterOptions
                .categories
                .map(
                  (
                    item
                  ) => (
                    <option
                      key={
                        item
                      }
                      value={
                        item
                      }
                    >
                      {
                        formatLabel(
                          item
                        )
                      }
                    </option>
                  )
                )
            }
          </select>


          <select
            value={
              filters.tenantId
            }
            onChange={
              (
                event
              ) =>
                dispatch(
                  setPlatformSupportFilters({
                    page:
                      1,

                    tenantId:
                      event.target.value,
                  })
                )
            }
          >
            <option value="">
              All Tenants
            </option>

            {
              filterOptions
                .tenants
                .map(
                  (
                    tenant
                  ) => (
                    <option
                      key={
                        tenant._id
                      }
                      value={
                        tenant._id
                      }
                    >
                      {
                        tenant.name ||
                        tenant.legalName
                      }
                    </option>
                  )
                )
            }
          </select>


          <input
            type="date"
            value={
              filters.fromDate
            }
            onChange={
              (
                event
              ) =>
                dispatch(
                  setPlatformSupportFilters({
                    page:
                      1,

                    fromDate:
                      event.target.value,
                  })
                )
            }
          />


          <input
            type="date"
            value={
              filters.toDate
            }
            onChange={
              (
                event
              ) =>
                dispatch(
                  setPlatformSupportFilters({
                    page:
                      1,

                    toDate:
                      event.target.value,
                  })
                )
            }
          />

        </div>


        {
          error
            ?
            (
              <div
                className="platform-support-error"
              >
                {
                  error.message ||
                  "Unable to load support tickets."
                }
              </div>
            )
            :
            null
        }


        <div
          className="platform-support-table-card"
        >

          <div
            className="platform-support-table-scroll"
          >

            <table>

              <thead>
                <tr>
                  <th>
                    Ticket
                  </th>

                  <th>
                    Customer
                  </th>

                  <th>
                    Issue
                  </th>

                  <th>
                    Source
                  </th>

                  <th>
                    Priority
                  </th>

                  <th>
                    Status
                  </th>

                  <th>
                    Created
                  </th>

                  <th>
                    Action
                  </th>
                </tr>
              </thead>


              <tbody>

                {
                  listLoading
                    ?
                    (
                      <tr>
                        <td
                          colSpan="8"
                          className="platform-support-empty"
                        >
                          Loading...
                        </td>
                      </tr>
                    )
                    :
                    tickets.length ===
                    0
                      ?
                      (
                        <tr>
                          <td
                            colSpan="8"
                            className="platform-support-empty"
                          >
                            No support tickets found.
                          </td>
                        </tr>
                      )
                      :
                      tickets.map(
                        (
                          ticket
                        ) => (
                          <tr
                            key={
                              ticket._id
                            }
                          >

                            <td>
                              <strong>
                                {
                                  ticket.ticketNumber
                                }
                              </strong>

                              <small>
                                {
                                  ticket.orderNumber ||
                                  "No order"
                                }
                              </small>
                            </td>


                            <td>
                              <strong>
                                {
                                  ticket.name
                                }
                              </strong>

                              <span>
                                {
                                  ticket.mobile
                                }
                              </span>
                            </td>


                            <td>
                              <strong>
                                {
                                  formatLabel(
                                    ticket.category
                                  )
                                }
                              </strong>

                              <span>
                                {
                                  ticket.subject
                                }
                              </span>
                            </td>


                            <td>
                              <strong>
                                {
                                  ticket
                                    .tenantId
                                    ?.name ||
                                  "Public"
                                }
                              </strong>

                              <small>
                                {
                                  ticket.sourceHost ||
                                  "-"
                                }
                              </small>
                            </td>


                            <td>
                              <span
                                className={`platform-support-priority priority-${String(
                                  ticket.priority ||
                                  ""
                                ).toLowerCase()}`}
                              >
                                {
                                  formatLabel(
                                    ticket.priority
                                  )
                                }
                              </span>
                            </td>


                            <td>
                              <span
                                className="platform-support-status"
                              >
                                {
                                  formatLabel(
                                    ticket.status
                                  )
                                }
                              </span>
                            </td>


                            <td>
                              {
                                formatDate(
                                  ticket.createdAt
                                )
                              }
                            </td>


                            <td>
                              <button
                                type="button"
                                className="platform-support-view"
                                onClick={
                                  () =>
                                    openDetails(
                                      ticket._id
                                    )
                                }
                              >
                                <FiEye />

                                View
                              </button>
                            </td>

                          </tr>
                        )
                      )
                }

              </tbody>

            </table>

          </div>


          <div
            className="platform-support-pagination"
          >

            <span>
              Page {
                pagination.page
              } / {
                pagination.totalPages
              } • {
                pagination.total
              } records
            </span>


            <div>
              <button
                type="button"
                disabled={
                  pagination.page <=
                  1
                }
                onClick={
                  () =>
                    dispatch(
                      setPlatformSupportFilters({
                        page:
                          pagination.page -
                          1,
                      })
                    )
                }
              >
                <FiChevronLeft />
              </button>


              <button
                type="button"
                disabled={
                  pagination.page >=
                  pagination.totalPages
                }
                onClick={
                  () =>
                    dispatch(
                      setPlatformSupportFilters({
                        page:
                          pagination.page +
                          1,
                      })
                    )
                }
              >
                <FiChevronRight />
              </button>
            </div>

          </div>

        </div>


        {
          detailsOpen
            ?
            (
              <div
                className="platform-support-dialog-overlay"
              >

                <div
                  className="platform-support-dialog"
                >

                  <div
                    className="platform-support-dialog-header"
                  >

                    <div>
                      <span>
                        SUPPORT TICKET
                      </span>

                      <h3>
                        {
                          selectedTicket
                            ?.ticketNumber ||
                          "Ticket Details"
                        }
                      </h3>
                    </div>


                    <button
                      type="button"
                      onClick={
                        () =>
                          setDetailsOpen(
                            false
                          )
                      }
                    >
                      <FiX />
                    </button>

                  </div>


                  {
                    detailsLoading
                      ?
                      (
                        <div
                          className="platform-support-dialog-loading"
                        >
                          Loading...
                        </div>
                      )
                      :
                      selectedTicket
                        ?
                        (
                          <div
                            className="platform-support-dialog-body"
                          >

                            <div
                              className="platform-support-detail-grid"
                            >

                              <div>
                                <span>
                                  Customer
                                </span>

                                <strong>
                                  {
                                    selectedTicket.name
                                  }
                                </strong>
                              </div>


                              <div>
                                <span>
                                  Mobile
                                </span>

                                <strong>
                                  {
                                    selectedTicket.mobile
                                  }
                                </strong>
                              </div>


                              <div>
                                <span>
                                  Email
                                </span>

                                <strong>
                                  {
                                    selectedTicket.email ||
                                    "-"
                                  }
                                </strong>
                              </div>


                              <div>
                                <span>
                                  Category
                                </span>

                                <strong>
                                  {
                                    formatLabel(
                                      selectedTicket.category
                                    )
                                  }
                                </strong>
                              </div>


                              <div>
                                <span>
                                  Order
                                </span>

                                <strong>
                                  {
                                    selectedTicket.orderNumber ||
                                    "-"
                                  }
                                </strong>
                              </div>


                              <div>
                                <span>
                                  Storefront
                                </span>

                                <strong>
                                  {
                                    selectedTicket.sourceHost ||
                                    "-"
                                  }
                                </strong>
                              </div>

                            </div>


                            <section>
                              <h4>
                                Subject
                              </h4>

                              <p>
                                {
                                  selectedTicket.subject
                                }
                              </p>
                            </section>


                            <section>
                              <h4>
                                Customer Message
                              </h4>

                              <p
                                className="platform-support-message"
                              >
                                {
                                  selectedTicket.message
                                }
                              </p>
                            </section>


                            {
                              Array.isArray(
                                selectedTicket.attachments
                              ) &&
                              selectedTicket
                                .attachments
                                .length >
                              0
                                ?
                                (
                                  <section>
                                    <h4>
                                      Attachments
                                    </h4>

                                    <div
                                      className="platform-support-files"
                                    >
                                      {
                                        selectedTicket
                                          .attachments
                                          .map(
                                            (
                                              file,
                                              index
                                            ) => (
                                              <a
                                                key={
                                                  `${file.path}-${index}`
                                                }
                                                href={
                                                  fileUrl(
                                                    file.path
                                                  )
                                                }
                                                target="_blank"
                                                rel="noreferrer"
                                              >
                                                {
                                                  file.originalName ||
                                                  file.filename ||
                                                  `Attachment ${index + 1}`
                                                }
                                              </a>
                                            )
                                          )
                                      }
                                    </div>
                                  </section>
                                )
                                :
                                null
                            }


                            <div
                              className="platform-support-action-grid"
                            >

                              <label>
                                <span>
                                  Status
                                </span>

                                <select
                                  value={
                                    selectedTicket.status
                                  }
                                  disabled={
                                    actionLoading
                                  }
                                  onChange={
                                    async (
                                      event
                                    ) => {

                                      await dispatch(
                                        updatePlatformSupportStatus({
                                          id:
                                            selectedTicket._id,

                                          status:
                                            event.target.value,
                                        })
                                      );


                                      refreshAfterAction();

                                    }
                                  }
                                >

                                  {
                                    filterOptions
                                      .statuses
                                      .map(
                                        (
                                          item
                                        ) => (
                                          <option
                                            key={
                                              item
                                            }
                                            value={
                                              item
                                            }
                                          >
                                            {
                                              formatLabel(
                                                item
                                              )
                                            }
                                          </option>
                                        )
                                      )
                                  }

                                </select>
                              </label>


                              <label>
                                <span>
                                  Priority
                                </span>

                                <select
                                  value={
                                    selectedTicket.priority
                                  }
                                  disabled={
                                    actionLoading
                                  }
                                  onChange={
                                    (
                                      event
                                    ) =>
                                      dispatch(
                                        updatePlatformSupportPriority({
                                          id:
                                            selectedTicket._id,

                                          priority:
                                            event.target.value,
                                        })
                                      )
                                  }
                                >

                                  {
                                    filterOptions
                                      .priorities
                                      .map(
                                        (
                                          item
                                        ) => (
                                          <option
                                            key={
                                              item
                                            }
                                            value={
                                              item
                                            }
                                          >
                                            {
                                              formatLabel(
                                                item
                                              )
                                            }
                                          </option>
                                        )
                                      )
                                  }

                                </select>
                              </label>

                            </div>


                            <label
                              className="platform-support-textarea"
                            >
                              <span>
                                Internal Notes
                              </span>

                              <textarea
                                rows="5"
                                value={
                                  internalNotes
                                }
                                onChange={
                                  (
                                    event
                                  ) =>
                                    setInternalNotes(
                                      event.target.value
                                    )
                                }
                              />

                              <button
                                type="button"
                                disabled={
                                  actionLoading
                                }
                                onClick={
                                  () =>
                                    dispatch(
                                      updatePlatformSupportNotes({
                                        id:
                                          selectedTicket._id,

                                        internalNotes,
                                      })
                                    )
                                }
                              >
                                Save Notes
                              </button>
                            </label>


                            <label
                              className="platform-support-textarea"
                            >
                              <span>
                                Resolution / Response
                              </span>

                              <textarea
                                rows="5"
                                value={
                                  resolution
                                }
                                onChange={
                                  (
                                    event
                                  ) =>
                                    setResolution(
                                      event.target.value
                                    )
                                }
                              />

                              <button
                                type="button"
                                disabled={
                                  actionLoading
                                }
                                onClick={
                                  () =>
                                    dispatch(
                                      updatePlatformSupportResolution({
                                        id:
                                          selectedTicket._id,

                                        resolution,
                                      })
                                    )
                                }
                              >
                                Save Resolution
                              </button>
                            </label>

                          </div>
                        )
                        :
                        null
                  }

                </div>

              </div>
            )
            :
            null
        }

      </div>
    );
  };


export default
  PlatformSupportPage;
